var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingProfileButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15510",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15510",
    transform: "translate(-10903 -19093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15509",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15509",
    transform: "translate(63)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_9519",
    "data-name": "\\u9577\\u65B9\\u5F62 9519",
    width: 53,
    height: 53,
    transform: "translate(10840 19093)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u524D\\u9762\\u30AA\\u30D6\\u30B8\\u30A7\\u30AF\\u30C8\\u3067\\u578B\\u629C\\u304D_5",
    "data-name": "\\u524D\\u9762\\u30AA\\u30D6\\u30B8\\u30A7\\u30AF\\u30C8\\u3067\\u578B\\u629C\\u304D 5",
    d: "M-17848.32-3175.192a21.411,21.411,0,0,1-8.379-1.692,21.447,21.447,0,0,1-6.836-4.613,21.5,21.5,0,0,1-4.615-6.84,21.323,21.323,0,0,1-1.693-8.378,21.335,21.335,0,0,1,1.693-8.38,21.49,21.49,0,0,1,4.615-6.839,21.524,21.524,0,0,1,6.836-4.614,21.436,21.436,0,0,1,8.379-1.692,21.365,21.365,0,0,1,8.377,1.692,21.366,21.366,0,0,1,6.842,4.613,21.38,21.38,0,0,1,4.609,6.839,21.335,21.335,0,0,1,1.7,8.38,21.366,21.366,0,0,1-1.7,8.377,21.43,21.43,0,0,1-4.613,6.84,21.339,21.339,0,0,1-6.834,4.613A21.372,21.372,0,0,1-17848.32-3175.192Zm-9.637-16.131c-1.471,0-1.629,1.431-1.629,2.047a8.6,8.6,0,0,0,3.115,6.035,11.882,11.882,0,0,0,7.951,3.018,11.869,11.869,0,0,0,7.951-3.018,8.558,8.558,0,0,0,3.115-6.035c0-.615-.156-2.049-1.629-2.049a2.1,2.1,0,0,0-.389.038,42.165,42.165,0,0,1-9.049,1.005,42.826,42.826,0,0,1-9.055-1.005,2.006,2.006,0,0,0-.383-.032Z",
    transform: "translate(28777.844 22316.238)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingProfileButton);
export default __webpack_public_path__ + "static/media/settingProfileButton.574a5678329186d3e557cc4c7dfcd173.svg";
export { ForwardRef as ReactComponent };